import auth from '@middlewares/Auth';

export default [
  {
    url: '/custom-trips',
    page: 'custom-trips/Index',
    name: 'custom-trips',
    meta: {
      label: 'Custom Trips',
      layout: 'Dashboard',
      middleware: [auth],
      role: {
        only: ['tourist'],
      },
    },
    group: [
      {
        url: 'create',
        page: 'custom-trips/Create',
        name: 'new-custom-trip',
      },
    ],
  },
];
